import { ACCOUNTS_STORAGE_KEYS } from "../localStorageKeys/accounts";
import { TradingAccount } from "./types";
import { writeEssential } from "@/lib/storage/safeLocalStorage";

export const getStoredAccounts = (): TradingAccount[] => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const storedData = localStorage.getItem(ACCOUNTS_STORAGE_KEYS.CORE);

    if (!storedData) {
      return [];
    }

    const parsedData = JSON.parse(storedData);

    if (!Array.isArray(parsedData)) {
      console.error("Invalid accounts data in localStorage");
      return [];
    }

    return parsedData;
  } catch (error) {
    console.error("Error loading accounts from localStorage:", error);
    return [];
  }
};

export const saveAccounts = (accounts: TradingAccount[]): void => {
  if (typeof window === "undefined") {
    return;
  }

  // Essential: a lost write here means an account the user added silently disappears on reload.
  writeEssential(ACCOUNTS_STORAGE_KEYS.CORE, JSON.stringify(accounts));
};

export const clearStoredAccounts = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(ACCOUNTS_STORAGE_KEYS.CORE);
  } catch (error) {
    console.error("Error clearing accounts from localStorage:", error);
  }
};

export const getStoredActiveAccount = (): TradingAccount | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const storedData = localStorage.getItem(ACCOUNTS_STORAGE_KEYS.ACTIVE_ACCOUNT);
    
    if (!storedData) {
      return null;
    }
    
    return JSON.parse(storedData);
  } catch (error) {
    console.error("Error loading active account from localStorage:", error);
    return null;
  }
};

export const saveActiveAccount = (account: TradingAccount | null): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (account === null) {
      localStorage.removeItem(ACCOUNTS_STORAGE_KEYS.ACTIVE_ACCOUNT);
      return;
    }
  } catch (error) {
    console.error("Error clearing active account in localStorage:", error);
    return;
  }

  // Essential: losing this is what made the terminal reboot onto a stale account.
  writeEssential(ACCOUNTS_STORAGE_KEYS.ACTIVE_ACCOUNT, JSON.stringify(account));
};

export const clearStoredActiveAccountId = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(ACCOUNTS_STORAGE_KEYS.ACTIVE_ACCOUNT);
  } catch (error) {
    console.error("Error clearing active account ID from localStorage:", error);
  }
};
